var DeleteButton = /** @class */ (function () {
    function DeleteButton(button, deletePromtText) {
        this.deletePromtText = deletePromtText;
        this.entry = button;
        do {
            this.entry = this.entry.parentElement;
        } while (this.entry != null && !this.entry.classList.contains('subscription-entry'));
        button.addEventListener('click', this.onButtonClick.bind(this));
    }
    DeleteButton.prototype.onButtonClick = function () {
        var _a;
        if (confirm(this.deletePromtText)) {
            (_a = this.entry) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    return DeleteButton;
}());
export default DeleteButton;
